import React from "react";
import Button from "../";
import cx from "../../../utils/cx";
import s from "./index.css";

export default ({ active, className, ...props }) => (
  <Button
    className={cx({
      [s.full]: true,
      [s.fullActive]: active,
      [className]: className
    })}
    hoverClassName={s.fullHover}
    {...props}
  />
);



// WEBPACK FOOTER //
// ./src/components/Buttons/Full/index.js